import { defineComponent } from "vue";

export default defineComponent({
    template: `
        <div class="Expander" :class="{ 'Expander--margin': margin, ['Expander--' + type]: true }">
            <div v-if="visible && type == 'up'" class="Expander__body">
                <slot></slot>
            </div>

            <div class="Expander__header">
                <div class="Expander__widget">
                    <slot name="widget"></slot>
                </div>

                <button type="button" @click="visible = !visible">
                    {{ visible ? label_collapse : label_expand }}

                    <svg v-if="!visible" xmlns="http://www.w3.org/2000/svg" width="18" height="10" viewBox="0 0 18 10" fill="none">
                        <path d="M17 1L9 9L1 1" stroke="#005537"/>
                    </svg>

                    <svg v-if="visible" xmlns="http://www.w3.org/2000/svg" width="18" height="10" viewBox="0 0 18 10" fill="none">
                        <path d="M17 9L9 1L1 9" stroke="#005537"/>
                    </svg>
                </button>
            </div>

            <slot name="info"></slot>

            <div v-if="visible && type == 'down'" class="Expander__body">
                <slot></slot>
            </div>
        </div>
    `,

    emits: [
    ],

    props: {
        margin: { type: Boolean, default: false },

        expanded: { type: Boolean, default: true },

        type: { type: String, default: 'down' },

        label_expand: { type: String },
        label_collapse: { type: String },
    },

    data() {
        return {
            visible: this.expanded,
        };
    },
});
